import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { ServiceLevel } from '../webApi/DataModels'
import { map, filter } from 'lodash'
class ServiceLevelState {
  serviceLevels: ServiceLevel[] = []
  serviceLevelOptions: any[] = []
}

const mutations = <MutationTree<ServiceLevelState>>{
  setServiceLevels (state: ServiceLevelState, serviceLevels: ServiceLevel[]) {
    state.serviceLevels = serviceLevels
    state.serviceLevelOptions = serviceLevels.map((serviceLevel: ServiceLevel) => {
      var label = serviceLevel.Service_Level_Name
      return {
        value: serviceLevel.Service_Level_ID,
        label: label,
        selected: false
      }
    })
    window.sessionStorage.setItem('Service_Level_List', JSON.stringify(state.serviceLevels))
  },
  reset (state:ServiceLevelState) {
    state.serviceLevels = []
    state.serviceLevelOptions = []
  }
}

const actions = <ActionTree<ServiceLevelState, any>>{
  reset (store: ActionContext<ServiceLevelState, any>):void {
    store.commit('reset')
  },
  loadServiceLevels (store: ActionContext<ServiceLevelState, any>): Promise<any> {
    if (window.sessionStorage.getItem('Service_Level_List') != null) {
      // the list has already been stored in session
      store.commit('setServiceLevels', JSON.parse(window.sessionStorage.getItem('Service_Level_List')))
      return Promise.resolve('success')
    } else {
      // the list has not been stored in session yet, load from server
      return webApi.service_level.get_Service_Levels().then(
        (response) => {
          // Store the response
          store.commit('setServiceLevels', response.data)
          return Promise.resolve('success')
        }).catch((response) => {
        window.bus.$emit('openErrorModal', 'error loading service levels: ' + response.data.ExceptionMessage)
        return Promise.reject(response)
      })
    }
  }
}

const getters = <GetterTree<ServiceLevelState, any>>{
  serviceLevels: (state) => {
    return state.serviceLevels
  },
  serviceLevelOptions: (state) => {
    return state.serviceLevelOptions
  },
  serviceLevelNames (state:ServiceLevelState):any {
    return (serviceLevelIDs:number[]) => {
      return map(filter(state.serviceLevels, serviceLevel => (serviceLevelIDs.indexOf(serviceLevel.Service_Level_ID) > -1)), 'Service_Level_Name')
    }
  }
}

export default ({
  namespaced: true,
  state: new ServiceLevelState(),
  mutations,
  actions,
  getters
})
